import * as Yup from "yup";

export const supportingDocsValidations = (section, formType, dbFormSpec) => {
    if (section.active) {
        return Yup.object().shape({
            supportingDoc: Yup.array()
            .required(
               () => {
                console.log("dbFormSpec", dbFormSpec)
                console.log("numOfDocsExpected", dbFormSpec.idVerification.numOfDocsExpected)
                if (dbFormSpec.idVerification.numOfDocsExpected === 0) {
                  return false
               }
               else if (formType.includes('Patient')) {
                  return 'Please upload the required document(s)'
               }
               else {
                  return 'Please upload the required documents proving authority to act on behalf of the patient'
               }
              }
            )

              .test(
                'file-limit',
                section.fields.supportingDoc.validations.fileLimit.message,
                function checkIfFilesAreCorrectType(files){
                    
                    if (files) {
                      return files.length <= 2;
                    }
                    return true;
                  }
              )
              .test(
                'file-minimum',
                section.fields.supportingDoc.validations.fileMinimum.message,
                function checkIfFilesAreCorrectType(files){
                    
                    if (files && dbFormSpec.idVerification.numOfDocsExpected === 2 && formType.includes('Patient')) {
                      return files.length > 1;
                    }
                    return true;
                  }
              )
              .test(
                'is-file-big',
                'Please remove all files larger than 15mb',
                function checkIfFilesAreCorrectSize(files){
                    let valid = true
                    if (files) {
                      files.map(file => {
                        if (file.size > 1.5e+7) {
                          valid = false
                        }
                      })
                    }
                    return valid
                  }
              )
        });
    }  
};